<template>
  <div class="mx-1 mt-n3 bg-add-field-panel rounded">
    <custom-icon-view
      icon="fa fa-plus"
      icon-color="#2DB782"
      icon-background="#fff"
      variant="d-inline w-auto"
      title="Añadir Referido"
    />
    <div class="row px-4">
      <ValidationObserver
        ref="referralEvaluationFormObserver"
        class="w-100"
        tag="form"
        novalidate
      >
        <div class="row">
          <div class="col-12">
            <div class="row mx-1 pt-1">
              <div class="col-5 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="dropDownEvaluation"
                  mode="eager"
                  :rules="
                    `${field.dropDownEvaluation.required ? 'required' : ''}`
                  "
                >
                  <div class="font-weight-normal font-14 color-gray--6">
                    {{ field.dropDownEvaluation.label }}
                  </div>
                  <CustomDropDown
                    :id="field.dropDownEvaluation.name"
                    v-model="field.dropDownEvaluation.model"
                    :disabled="field.dropDownEvaluation.disabled"
                    :custom-error-msg="field.dropDownEvaluation.errorMsg"
                    :error="errors[0]"
                    :placeholder="field.dropDownEvaluation.placeHolder"
                    :fieldkey="field.dropDownEvaluation.fieldkey"
                    :fieldname="field.dropDownEvaluation.fieldname"
                    :options="field.dropDownEvaluation.items"
                    @input="getDisciplines"
                  />
                </ValidationProvider>
              </div>
              <div class="col-2 pt-1" />
              <div class="col-5 pt-1">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="dropDownDiscipline"
                  mode="eager"
                  :rules="
                    `${field.dropDownDiscipline.required ? 'required' : ''}`
                  "
                >
                  <div class="font-weight-normal font-14 color-gray--6">
                    {{ field.dropDownDiscipline.label }}
                  </div>
                  <CustomDropDown
                    :id="field.dropDownDiscipline.name"
                    v-model="field.dropDownDiscipline.model"
                    :disabled="field.dropDownDiscipline.disabled"
                    :custom-error-msg="field.dropDownDiscipline.errorMsg"
                    :error="errors[0]"
                    :placeholder="field.dropDownDiscipline.placeHolder"
                    :fieldkey="field.dropDownDiscipline.fieldkey"
                    :fieldname="field.dropDownDiscipline.fieldname"
                    :options="field.dropDownDiscipline.items"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-12 mx-3 mt-3">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :rules="field.textAreaReason.required ? 'required' : ''"
                >
                  <strong class="font-weight-normal font-14 color-gray--6">
                    {{ field.textAreaReason.label }}
                  </strong>
                  <CustomTextArea
                    v-show="field.textAreaReason.visible"
                    v-model="field.textAreaReason.model"
                    :disabled="field.textAreaReason.disabled"
                    :maxlength="field.textAreaReason.maxlength"
                    :rows="field.textAreaReason.rows"
                    :placeholder="field.textAreaReason.placeHolder"
                    :error="errors[0]"
                    :custom-error-msg="field.textAreaReason.errorMsg"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <div class="row">
      <div class="col text-right mt-2">
        <ActionButton
          i="fas fa-times-circle"
          variant="outline-danger btn-cancel danger m-2"
          @click="cancel"
        >
          {{ field.btnCancel.label }}
        </ActionButton>
        <ActionButton
          i="fa fa-save"
          variant="success m-2 pl-4 pr-4"
          @click="save"
        >
          {{ field.btnSave.label }}
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import loading from '@/mixin/loading.mixin';
import alert from '@/mixin/alert.mixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import disciplineCategories from '@/utils/constants/student/disciplineCategories';
import evaluationTypes from '@/utils/constants/student/evaluationTypes';
import CustomIconView from '@/components/common/CustomIconView';
import rpStatuses from '@/utils/constants/rp/rpStatuses';
import studentService from "@/modules/student/api";
import {
  ActionButton,
  CustomDropDown,
  CustomTextArea,
} from '@/components/common';

export default {
  mixins: [loading, alert],
  components: {
    ActionButton,
    CustomDropDown,
    ValidationObserver,
    ValidationProvider,
    CustomTextArea,
    CustomIconView,
  },
  data() {
    return {
      name: 'ReferralEvaluationRequestAdd',
      studentSie: store.getters['$_student/StudentSie'],
      ValidationTriggered: store.getters.getatValidationTriggered,
      apiUrl: '/api/studentEvaluation',
      field: {
        dropDownEvaluation: {
          name: 'dropDownEvaluation',
          required: true,
          disabled: false,
          label: 'Tipo de Servicio:',
          placeHolder: 'Seleccione',
          fieldkey: 'evaluationTypeId',
          fieldname: 'description',
          errorMsg: 'Favor de seleccionar un tipo de evaluación.',
          items: [],
          model: null,
        },
        dropDownDiscipline: {
          name: 'dropDownDiscipline',
          required: true,
          disabled: true,
          label: 'Servicio:',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'disciplineName',
          errorMsg: 'Favor de seleccionar una disciplina.',
          items: [],
          model: null,
        },
        textAreaReason: {
          name: 'textAreaReason',
          required: true,
          disabled: false,
          visible: true,
          label: 'Indique las necesidades académicas o funcionales que presenta el estudiante y cómo el especialista podría apoyar:',
          maxlength: 3000,
          rows: 5,
          placeHolder: 'Razón de Referido',
          errorMsg:
            'Favor de escribir una razón para solicitar esta evaluación.',
          model: null,
        },
        btnSave: {
          label: 'Guardar',
        },
        btnCancel: {
          label: 'Cancelar',
        },
        studentInfo: null,
        impedimentId: null
      },
    };
  },
  props: {
    referralsAdded: {
      type: Array,
      default: () => [],
    },
    sie: {
      default: null,
    },
  },
  computed: {
    mipeStudentInfo() {
      return this.$store.getters['$_student/getMipeStudent'];
    },
    activeReferrals() {
      return this.referralsAdded.filter(
        (x) =>
          x.referralStatusId !== rpStatuses.Inactivo &&
          x.referralStatusId !== rpStatuses.Denegado &&
          x.referralStatusId != rpStatuses.Procesado
      );
    },
    activeReferralIds() {
      return this.activeReferrals.map((x) => x.discipline.id);
    },
  },
  methods: {
    async getEvaluations() {
      this.$ApiGet(`${this.apiUrl}/EvaluationTypesTrianual`).then(
        (res) =>
          (this.field.dropDownEvaluation.items = res.data ? res.data : [])
      );
    },
    async getImpedimentId() {
      if(!this.mipeStudentInfo){
        await this.getStudentInfo(this.sie)
      }
      const mipeStudent = this.mipeStudentInfo ? this.mipeStudentInfo.mipeStudent ?? {} : this.studentInfo.mipeStudent ?? {};
     this.impedimentId = mipeStudent.impedimentId;
    },
    async getDisciplines() {
      const self = this;
      await self.getImpedimentId();
      self.field.dropDownDiscipline.model = null;
      const evaluationSelected = self.field.dropDownEvaluation.model;

      if (evaluationSelected) {
        let disciplineCategory = disciplineCategories.ValidForAppointment;
        let url = '';

        if (
          evaluationSelected.evaluationTypeId ===
          evaluationTypes.Evaluacion_Trianual
        ) {
          disciplineCategory = disciplineCategories.ValidForTriannual;
          url = `${self.apiUrl}/${self.studentSie ?? this.sie}/validDisciplineTypes/${this.impedimentId}`;
        } else
          url = `${self.apiUrl}/${self.studentSie ?? this.sie}/validDisciplineTypes/${evaluationSelected.evaluationTypeId}/${disciplineCategory}?isFromTrianual=true`;

        self.$ApiGet(url).then((res) => {
          let data = res.data ? res.data : [];

          if (self.referralsAdded.length > 0 && !this.sie) {
            this.activeReferralIds.forEach((referralsAddedDisciplineId) => {
              data = data.filter(
                (d) =>
                  referralsAddedDisciplineId ||
                  d.id !== referralsAddedDisciplineId
              );
            });
          }

          if (self.referralsAdded.length > 0 &&  !this.sie) {
            this.activeReferralIds.forEach((referralsAddedDisciplineId) => {
              data = data.filter((d) => d.id !== referralsAddedDisciplineId);
            });
          }

          if (self.referralsAdded.length > 0 && !this.sie) {
            [
              ...new Set(
                this.activeReferrals.map((x) => {
                  if (x.evaluation.id === evaluationSelected.evaluationTypeId) {
                    return x.discipline.id;
                  }
                })
              ),
            ].forEach((referralsAddedDisciplineId) => {
              data = data.filter((d) => d.id !== referralsAddedDisciplineId);
            });
          }

          self.field.dropDownDiscipline.items = data;
          self.field.dropDownDiscipline.disabled = false;
        });
      } else {
        self.field.dropDownDiscipline.disabled = true;
        self.field.dropDownDiscipline.items = [];
      }
    },
    async save() {
      const self = this;

      const isValid = await self.$refs.referralEvaluationFormObserver.validate();

      if (isValid) {
        const referral = {
          evaluation: {
            id: self.field.dropDownEvaluation.model.evaluationTypeId,
            name: self.field.dropDownEvaluation.model.description,
          },
          discipline: {
            id: self.field.dropDownDiscipline.model.id,
            name: self.field.dropDownDiscipline.model.disciplineName,
          },
          referralRequestReason: self.field.textAreaReason.model,
          status: 'Nuevo',
          referralStatusId: 1,
        };

        self.$emit('on-add', referral);
      }
    },
    cancel() {
      this.$emit('on-cancel');
    },
    async getStudentInfo(studentSieId) {
      const { data }  = (await studentService.getStudentDetailsBySie(studentSieId,false));
      this.studentInfo = data
    },
  },
  async mounted() {
    await this.getEvaluations();
  },
};
</script>

<style src="@/assets/css/component/radio-button.css"></style>
<style src="@/assets/css/component/datepicker.css"></style>
<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>
<style src="@/assets/css/component/messages.css"></style>

<style scoped>
.box-icon-button-custom >>> .btn {
  padding: 1px 23px;
  width: 100%;
}

.badge-modal-custom >>> .tag-badge-title {
  font-size: 20px;
}
.danger-text {
  color: #e85c5c;
}
.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}
.global-thead-dark {
  background-color: #3f5b60 !important;
}
.buttoneval {
  border: 1px solid #2db782;
  color: #2db782;
}
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}

.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.item-pane-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  margin-bottom: 10px;
  font: 400 14px/17px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 20px 10px 10px;
}

.item-pane-info p {
  margin-bottom: 10px;
}

.item-pane-info p i {
  margin-right: 8px;
  font-size: 16px;
}
.question-box {
  width: 65px;

  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 22px 12px; */
}
.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}
.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}
i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
.back {
  background-color: rgba(0, 0, 0, 0.03);
}
.bg-add-field-panel {
  background-color: #fafafa;
  padding: 10px !important;
}
</style>
